var map = {
	".": 70843,
	"./": 70843,
	"./index": 70843,
	"./index.js": 70843,
	"./resources/attach.png": 46881,
	"./resources/attachaudio.png": 22355,
	"./resources/attachfile.png": 24907,
	"./resources/attachimage.png": 6018,
	"./resources/attachvideo.png": 300,
	"./resources/close.png": 66736,
	"./resources/createpoll.png": 98565,
	"./resources/heart.png": 70240,
	"./resources/insertemoji.png": 26799,
	"./resources/insertsticker.png": 32884,
	"./resources/launchcollaborativedocument.png": 68951,
	"./resources/launchcollaborativewhiteboard.png": 17609,
	"./resources/sendmessage.png": 22399,
	"./style": 39733,
	"./style.js": 39733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37783;